import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "justify-content-center" }
const _hoisted_2 = {
  class: "card bg-secondary border-0 mb-0 pt-5",
  style: {"height":"100vh","border-radius":"0"}
}
const _hoisted_3 = { class: "card-header bg-transparent" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted text-center mt-2 mb-3" }, null, -1)
const _hoisted_5 = {
  class: "text-muted text-center mt-1",
  style: {"margin-bottom":"-20px"}
}
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-center text-muted mb-4" }, [
  /*#__PURE__*/_createElementVNode("small", null, "Sign In")
], -1)
const _hoisted_10 = {
  role: "form",
  ref: "loginForm",
  class: "mb-2"
}
const _hoisted_11 = { class: "form-group mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "mr-2 ni ni-email-83" }, null, -1)
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "mr-2 ni ni-lock-circle-open" }, null, -1)
const _hoisted_15 = { class: "d-flex mt-5" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "text-center text-muted mb-2"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("small", null, "SSO Sign In", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  class: "d-flex mb-2",
  key: "social"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_LoginFooter = _resolveComponent("LoginFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: _ctx.logo(),
            class: "w-50"
          }, null, 8, _hoisted_6)
        ]),
        _createElementVNode("img", {
          src: _ctx.logo(),
          class: "w-50",
          hidden: ""
        }, null, 8, _hoisted_7)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("form", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_n_input, {
              value: _ctx.login.value.email,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.login.value.email) = $event)),
              name: "email",
              type: "text",
              size: "large",
              placeholder: "Email",
              status: _ctx.login.result.email.message ? 'error' : 'success'
            }, {
              prefix: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }, 8, ["value", "status"]),
            _withDirectives(_createElementVNode("p", { class: "font-italic h5 pt-2 text-danger" }, " *" + _toDisplayString(_ctx.login.result.email.message), 513), [
              [_vShow, _ctx.login.result.email.message]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_n_input, {
              value: _ctx.login.value.password,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.login.value.password) = $event)),
              name: "password",
              type: "password",
              "show-password-on": "click",
              size: "large",
              placeholder: "Password",
              status: _ctx.login.result.password.message ? 'error' : 'success'
            }, {
              prefix: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }, 8, ["value", "status"]),
            _withDirectives(_createElementVNode("p", { class: "font-italic h5 pt-2 text-danger" }, " *" + _toDisplayString(_ctx.login.result.password.message), 513), [
              [_vShow, _ctx.login.result.password.message]
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_n_button, {
              strong: "",
              type: "primary",
              class: "flex-fill",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.authenticate())),
              ghost: !_ctx.login.value.email || !_ctx.login.value.password,
              disabled: !_ctx.login.value.email || !_ctx.login.value.password
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Sign in ")
              ]),
              _: 1
            }, 8, ["ghost", "disabled"])
          ])
        ], 512),
        (!_ctx.isSocialEmpty())
          ? (_openBlock(), _createElementBlock("hr", _hoisted_16))
          : _createCommentVNode("", true),
        (!_ctx.isSocialEmpty())
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socials, (social) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createVNode(_component_n_button, {
              ghost: "",
              color: social.color,
              class: "flex-fill",
              onClick: ($event: any) => (_ctx.socialLogin(social))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(social.name), 1)
              ]),
              _: 2
            }, 1032, ["color", "onClick"])
          ]))
        }), 128))
      ]),
      _createVNode(_component_LoginFooter)
    ])
  ]))
}